import { getBrand, DEFAULT_BRAND } from "@/config/brand";
import { Link } from "@tanstack/react-router";

interface LegalFooterProps {
  className?: string;
  align?: "left" | "center";
}

/**
 * Institutional legal footer rendered across welcome, auth, help,
 * admin and tenant surfaces.
 */
export function LegalFooter({ className = "", align = "center" }: LegalFooterProps) {
  const brand = typeof window === "undefined" ? DEFAULT_BRAND : getBrand();
  const alignCls = align === "center" ? "text-center" : "text-left";
  return (
    <footer
      className={`mt-8 border-t border-border/40 px-4 py-4 text-[10px] leading-relaxed text-muted-foreground/70 ${alignCls} ${className}`}
    >
      <p className="mx-auto max-w-3xl">{brand.legalFooterText}</p>
      <p className="mx-auto mt-1 max-w-3xl opacity-80">{brand.copyrightText}</p>
      <p className="mx-auto mt-2 max-w-3xl">
        <Link to="/terminos" className="font-bold text-primary/80 hover:underline">Términos</Link>
        <span className="px-1.5">·</span>
        <Link to="/privacidad" className="font-bold text-primary/80 hover:underline">Privacidad</Link>
        <span className="px-1.5">·</span>
        <Link to="/ajustes/privacidad" className="font-bold text-primary/80 hover:underline">Preferencias</Link>
      </p>
    </footer>
  );
}